import React from 'react'
import { PlacementSummary } from '../../../services/api'
import pvStyles from '../PagePreview.module.scss'

// Mirrors apps/tennis.com/src/components/Merchandising/BannerImageWidget.tsx.
// The CMS-side widgets endpoint left-joins the desktop image onto `preview_url`,
// so we don't need a separate fetch to render the banner in preview.
const BannerImagePreview: React.FC<{ placement: PlacementSummary }> = ({ placement }) => {
  const widget = placement.widget
  const meta = widget?.metadata || {}
  const imageUrl = widget?.preview_url || null
  const altText: string = meta.alt_text || placement.name || ''
  const caption: string | undefined = meta.caption
  const linkUrl: string | undefined = meta.link_url?.trim() || undefined

  const image = imageUrl ? (
    <img src={imageUrl} alt={altText} className={pvStyles.pvBannerImage} />
  ) : (
    <div className={pvStyles.pvBannerPlaceholder}>
      <span className={pvStyles.pvPlaceholderIcon}>🖼️</span>
      <span>No image uploaded</span>
    </div>
  )

  // Always open in a new tab from the preview so the editor doesn't lose
  // context even if the real placement is configured for same-tab.
  const wrapped = linkUrl ? (
    <a
      href={linkUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={pvStyles.pvBannerLink}
    >
      {image}
    </a>
  ) : image

  return (
    <div className={pvStyles.pvBannerPreview}>
      {wrapped}
      {caption && <p className={pvStyles.pvBannerCaption}>{caption}</p>}
    </div>
  )
}

export default BannerImagePreview
